export const environment = {
  APP_NAME: 'ImIn',
  API_BASE_URL: '/api',
  production: true,

  CHAT_HOST   : 'imin.of1.weborchestra.org/ws/6262',
  CHAT_KEY    : 'AQAAAAABAADv4t8MBihzjJOEhqaX9RpL',
  CHAT_SECURE : true,
};
